import { Coordinates, Optional } from '@rygen/rygen-ui/model';

export class MapDetailsResponse {
  stopCoordinates: Array<Optional<Coordinates>>;
  legCoordinates: Coordinates[][];
  eventCoordinates: Array<Optional<Coordinates>>;

  constructor(opts: MapDetailsResponse) {
    this.stopCoordinates = opts.stopCoordinates.map((c) => {
      return c ? new Coordinates(c) : undefined;
    });

    this.legCoordinates = opts.legCoordinates.map((leg) => {
      return leg.map((c) => new Coordinates(c));
    });

    this.eventCoordinates = opts.eventCoordinates.map((c) => {
      return c ? new Coordinates(c) : undefined;
    });
  }
}
